<template>
    <div class="McustomerService">
        <div class="pic">
            <img src="../../assets/img/service－bg.png" alt="">
            <p>
                橙蟹帮助客户，实现企业规范服务<br>
                让我们一起深入探索财务领域的过去未来
            </p>
        </div>

        <main class="main">
            <div class="flow">
                <img src="../../assets/img/service－image－2.png" alt="">
            </div>

            <div class="case" v-for="(item,i) in caseList" :key="i">
                <h3>{{item.title}}</h3>
                <p>服务对象（服务名称）：<span class="pair">{{item.serviceObject}}</span></p>
                <p>企业行业：<span class="pair">{{item.companyIndustry}}</span></p>
                <p>企业规模：<span class="pair">{{item.companyScale}}</span></p>
                <p>最常用服务：<span class="pair">{{item.cooperationPurpose}}</span></p>
                <p>合作橙蟹的目的：<span class="pair">{{item.oftenService}}</span></p>
                <a @click="jupm(item.customerServiceId)">查看详情></a>
            </div>
        </main>
    </div>
</template>

<script>
    import { customerService } from '../../api/api.js'
    export default {
        name: 'McustomerService',
        created() {
            customerService().then(res => {
                for (let i = 0; i < res.data.data.list.length; i++) {
                    if (res.data.data.list[i].customerServiceStatus == '1') {
                        this.caseList.push(res.data.data.list[i])
                    }
                }
            })
        },
        data() {
            return {
                caseList: []
            }
        },
        methods: {
            jupm(id) {
                this.$router.push({ path: '/MserverDetail/' + id });
            }
        }
    }
</script>

<style scoped lang='scss'>
    // 图片
    .pic {
        width: 100%;
        height: 21.428571rem;
        // height: 150px;
        text-align: center;
        position: relative;

        img {
            width: 100%;
            height: 100%;
        }

        p {
            font-size: 18px;
            font-weight: 900;
            color: #ffffff;
            position: absolute;
            margin-top: -28%;
            margin-left: 8%;
        }
    }

    .main {
        background-color: #f5f5f5;
        padding-bottom: 6%;

        .flow {
            padding: 6% 0 2% 0;

            img {
                width: 100%;
            }
        }

        .case {
            background-color: #fff;
            margin: 4% 4%;
            padding: 2% 2%;

            h3 {
                text-align: center;
                color: #2e324f;
                padding: 2% 0 4% 0;
                font-size: 22px
            }

            p {}
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/mobile/McustomerService.vue